import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { Link as RouterLink } from 'react-router-dom';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TradingButton from '../components/Trader/TradingButton';
import { useLocation } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';


export default function Footer() {
  const [value, setValue] = React.useState(0);
  const ref = React.useRef(null);
  const location = useLocation();
  const { pathname } = location;

  return (
    <Box sx={{ display: {md: 'none'},  pb: 7 }} ref={ref}>
      <CssBaseline />
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0,   }} elevation={3}>
      {pathname === '/trade' ? 
         <TradingButton/>
        : 
        <BottomNavigation
        // 36492d
        // bce70c
        
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction component={RouterLink} to="/" label="Home" icon={
             <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738083863/home_uktfab.png' sx={{ padding: '5px', width: 40, height: 40, color: '#fff'}}>
            </Avatar>  
          } />
          <BottomNavigationAction component={RouterLink} to="/connect-wallet" label="Link Wallet" icon={
            <Avatar src='https://res.cloudinary.com/dqi4rtyvh/image/upload/v1738590768/connected_o8hlwu.png' sx={{ padding: '5px', width: 40, height: 40, color: '#fff'}}>
          </Avatar> } />

          {/* <BottomNavigationAction component={RouterLink} to="/start-trading" label="Trade" icon={
            <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738083863/stock_qwhsip.png' sx={{ padding: '5px', width: 40, height: 40, color: '#fff'}}>
            </Avatar> 
            } /> */}
          <BottomNavigationAction component={RouterLink} to="/account-wallet" label="History" icon={
            <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068352/usdt_hmpls3.png' sx={{ padding: '5px', width: 40, height: 40, color: '#fff'}}>
            </Avatar> 
          } />

          <BottomNavigationAction component={RouterLink} to="/assets" label="Assets" icon={
            <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068347/wallet_1_vmr3li.png' sx={{ padding: '5px', width: 40, height: 40, color: '#fff'}}>
            </Avatar> 
          } />
          
          {/* <BottomNavigationAction label="Our Menu" icon={<MenuBookIcon />}/> */}
          
        </BottomNavigation>
        }
      </Paper>
    </Box>
  );
}
